module.exports = __webpack_public_path__ + "assets/images/4-13_tvn2.jpg";